import classNames from 'classnames';
import React from 'react';
import clearIcon from '../icons/clear.svg';
import dragIcon from '../icons/drag.svg';
import IconButton from './IconButton';
import styles from './ReorderableListRow.module.scss';
import SVGIcon from './SVGIcon';

export type BasicReorderableItem = { id: string };

interface ReorderableRowProps<T> {
  item: T;
  isDragging: boolean;
  index: number;
  allowRemove: boolean;
  onRemove?: (index: number) => void;
  renderItem: (item: T, index: number) => JSX.Element;
}

const ReorderableListRow = <T extends BasicReorderableItem>({
  item,
  isDragging,
  index,
  allowRemove,
  onRemove,
  renderItem,
}: ReorderableRowProps<T>) => {
  return (
    <div
      className={classNames(styles.row, {
        [styles.isDragging]: isDragging,
      })}
    >
      <SVGIcon className={styles.dragIcon} size="small" coloringWith="fill">
        {dragIcon}
      </SVGIcon>
      {renderItem(item, index)}
      {allowRemove && onRemove && (
        <IconButton
          className={styles.deleteButton}
          onClick={() => onRemove(index)}
          size="small"
        >
          {clearIcon}
        </IconButton>
      )}
    </div>
  );
};

export default ReorderableListRow;
